<div class="layout-topbar">
    <a class="logo" href="/dashboard">
        <img src="assets/img/logo-new.png" alt="california-logo"/>
    </a>
    <a joyrideStep="toggleMenu" [title]="'tour.toggle-menu-title' | translate" [text]="'tour.toggle-menu-description' | translate" id="menu-button" href="#" (click)="appMain.onMenuButtonClick($event)">
        <i class="pi pi-align-left"></i>
    </a>



</div>
